import api from "./index";

// Payment Plan Interfaces
export interface CreateUpdatePaymentPlanPayload {
  id?: string;
  treatmentId: string;
  patientId: string;
  doctorId: string;
  treatmentPlanId: string;
  addComment: string;
  treatmentCost: number | "";
  discount: number | "";
  additionalCharges: number | "";
  reasonForExtraCharge: string;
}

export interface PaymentPlan {
  id: string; // internal id we derive (same as planId)
  planId?: string;
  treatmentId?: string;
  treatment?: { id: string; treatmentType?: string };
  patientId?: string;
  patient?: { id: string; name: string };
  doctorId?: string;
  doctor?: { id: string; name: string };
  treatmentPlanId?: string;
  treatmentPlan?: { id: string; type?: string };
  addComment?: string;
  treatmentCost?: number;
  discount?: number;
  additionalCharges?: number;
  reasonForExtraCharge?: string;
  totalPayable?: number;
  totalReceived?: number;
  pendingAmount?: number;
  remainingAmount?: number;
  status?: string;
  transactions?: PaymentTransaction[];
  createdAt?: string;
  updatedAt?: string;
}

// Payment Transaction Interfaces
export interface CreatePaymentTransactionPayload {
  planId: string;
  amountReceived: number;
  addComment: string;
  paymentDate: string;
}

export interface UpdatePaymentTransactionPayload {
  amountReceived: number;
  addComment: string;
  paymentDate: string;
}

export interface PaymentTransaction {
  id: string; // internal id we derive (same as transactionId)
  transactionId?: string;
  planId?: string;
  amountReceived: number;
  addComment?: string;
  paymentDate: string;
  patientId?: string;
  treatmentId?: string;
  paymentNumber?: string;
  createdAt?: string;
  updatedAt?: string;
}

// Payment Service
export const PaymentService = {
  // Create or Update Payment Plan
  createOrUpdatePlan: async (data: CreateUpdatePaymentPlanPayload) => {
    return api.post("/payment/create-update-plan", data);
  },

  // Get Payment Plan by ID
  getPlanById: async (planId: string) => {
    return api.get(`/payment/plan/${planId}`);
  },

  // Get all payment plans for a patient
  getPlansByPatient: async (patientId: string) => {
    return api.get(`/payment/plans/patient/${patientId}`);
  },

  // Add Payment Transaction
  addTransaction: async (data: CreatePaymentTransactionPayload) => {
    return api.post("/payment/transaction", data);
  },

  // Update Payment Transaction
  updateTransaction: async (
    transactionId: string,
    data: UpdatePaymentTransactionPayload
  ) => {
    return api.post(`/payment/transaction/${transactionId}`, data);
  },

  // Delete Payment Transaction
  deleteTransaction: async (transactionId: string) => {
    return api.get(`/payment/transaction/delete/${transactionId}`);
  },
};

export default PaymentService;

